export enum KEY {
  PRODUCT,
  RESOURCES,
  PARTNERS,
  COMPANY,
  SUPPORT,
}

export enum MODIFIERS {
  NEW = 'new',
}

export type MenuItem = { i18nKey: string; path: string };
export type MenuItemWithColumns = {
  key: KEY;
  i18nKey: string;
  columns: (ColumnItem | ColumnItemTitle)[][];
};

export type ColumnItemTitle = { i18nKey: string };
export type ColumnItem = { i18nKey: string; path: string; modifier: MODIFIERS };

export type Menu = (MenuItem | MenuItemWithColumns)[];
